import { Store, SyncFilters } from "../../../types"
import { useState } from "react";
import Close from "../../../assets/Close"
import NoImage from '../../../assets/NoImage.jpg';
import { syncCall, syncStoreWithFilters } from "../../../lib/admin";
import { useAuth } from "../../../utils/authorization";
import { useHasScope } from "../../../utils/Permission";
import { Tooltip } from "@mui/material";

type Props =
    {
        store: Store,
        close: () => void,
        syncStore: () => void
    }

export default function StoreCardSyncModal({ store, close }: Props) {
    const [navigation, setNavigation] = useState(false);
    const [products, setProducts] = useState(false);
    const [categories, setCategories] = useState(false);
    const [brands, setBrands] = useState(false);
    const [ranges, setProductRanges] = useState(false);
    const [variants, setVariants] = useState(false);
    const [collections, setCollections] = useState(false);
    const [meta, setMeta] = useState(false);
    const [parser, setParser] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { user } = useAuth();
    const hasSyncUnlimited = useHasScope('stores:sync:unlimited');

    const checkStoreTime: (store: Store) => boolean = (store: Store) => {
        var now = new Date();
        var now_utc = new Date(now.toUTCString().slice(0, -5));
        var lastUpdate = new Date(store.lastUpdate);

        if (getMinDiff(now_utc, lastUpdate) < 10) {
            return false;
        }
        else return true;
    }

    const getMinDiff: (startDate: any, endDate: any) => number = (startDate: any, endDate: any) => {
        const msInMinute = 60 * 1000;
        return Math.floor(
            Math.abs(endDate - startDate) / msInMinute
        );
    }

    const handleSyncFilters = async () => {
        if (!navigation && !products && !categories && !brands && !ranges && !variants && !collections && !meta && !parser) {
            setError(true);
            setErrorMessage("Select at least one filter to sync.");
        }
        if (!checkStoreTime(store) && !hasSyncUnlimited) {
            setError(true);
            setErrorMessage("Last sync was less than 10 minutes ago, try again later.");
        } else {
            const body: SyncFilters = {
                navigation: navigation,
                products: products,
                categories: categories,
                brands: brands,
                ranges: ranges,
                variants: variants,
                collections: collections,
                metafields: meta,
                parser: parser
            }
            try {
                const response = await syncStoreWithFilters(body, store.id, checkStoreTime(store), user?.email);
                if (response.ok) {
                    setError(false);
                    setErrorMessage("");
                    close();
                } else {
                    const errorText = await response.text();
                    setErrorMessage(errorText);
                    setError(true);
                }
            } catch (error) {
                setError(true);
                setErrorMessage("Something went wrong. Please try again later.");
            }
        }
    }

    const handleSyncAll = async () => {
        if (!checkStoreTime(store) && !hasSyncUnlimited) {
            setError(true);
            setErrorMessage('Last sync was less than 10 minutes ago, try again later.');
            return;
        }

        try {
            const result = await syncCall(store.id, { email: user?.email });
            if (result === '') {
                setError(false);
                setErrorMessage('');
            } else {
                setError(true);
                setErrorMessage(typeof result === 'string' ? result : (result?.message ?? result?.error ?? 'Something went wrong. Please try again later.'));
            }
        } catch {
            setError(true);
            setErrorMessage('Something went wrong. Please try again later.');
        }
    };

    return (
        <div className="sync-modal-overlay">
            <div className="sync-modal center">
                <div className="synModal">
                    <div className="storeLogo filter">
                        {!store?.logo || store?.logo.toLowerCase() === "x" ? (
                            <img src={NoImage} alt={`logo-${store.friendlyName}`} id="logo-store" />
                        ) : (
                            <img src={store?.logo} alt={`logo-${store.friendlyName}`} id="logo-store" />
                        )}
                    </div>
                    <div className="synModal__wrapper">
                        <div className="synModal__header">
                            <div className="synModal__close">
                                <button onClick={close}>Close <Close></Close></button>
                            </div>
                            <div className="synModal__title">
                                <h1>Entities to synchronize:</h1>
                            </div>
                        </div>
                        <div className="synModal__content">
                            <div className="synModal__greyArea">
                                <div className="synModal__parentItem">
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={navigation} onClick={() => setNavigation(!navigation)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Navigation menu</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Navigation menu</p>
                                    </div>
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={products} onClick={() => setProducts(!products)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Products</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Products</p>
                                    </div>
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={categories} onClick={() => setCategories(!categories)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Categories</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Categories</p>
                                    </div>
                                    {/* 
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={brands} onClick={() => setBrands(!brands)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Brands</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Brands</p>
                                    </div>
                                </div>
                                <div className="synModal__parentItem">
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={ranges} onClick={() => setProductRanges(!ranges)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Product Ranges</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Product Ranges</p>
                                    </div>
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={variants} onClick={() => setVariants(!variants)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Product Variants</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Product Variants</p>
                                    </div>
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={collections} onClick={() => setCollections(!collections)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Shopify Collections</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Shopify Collections</p>
                                    </div>
                                    {/*
                                    <div className="synModal__item">
                                        <label className="switch">
                                            <input type="checkbox" checked={meta} onClick={() => setMeta(!meta)} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Metafields</p>
                                    </div>
                                    */}
                                    <div className="synModal__item disabled">
                                        <label className="switch">
                                            <input type="checkbox" checked={false} disabled />
                                            <span className="slider round"></span>
                                        </label>
                                        <p>Metafields</p>
                                    </div>
                                </div>
                                {/*
                                    <div className="synModal__item">
                                        <label>
                                            <input type="checkbox" checked={parser} onClick={() => setParser(!parser)} /> With Parser
                                        </label>
                                    </div>
                                    */}
                                <div className="synModal__item disabled">
                                    <label>
                                        <input type="checkbox" checked={false} disabled /> With Parser
                                    </label>
                                </div>
                                <div className="synModal__btnSync">
                                    {/*
                                    <button className="edit-button save" onClick={handleSyncFilters}>Sync these filters</button>
                                    */}
                                    <Tooltip
                                        title="Temporarily disabled"
                                        arrow
                                        PopperProps={{
                                            className: 'sync-tooltip-popper'
                                        }}
                                    >
                                        <span className="sync-disabled-wrapper">
                                            <button className="edit-button save disabled" disabled={true} onClick={handleSyncFilters}>Sync these filters</button>
                                        </span>
                                    </Tooltip>
                                </div>
                                <div className="error-sync">
                                    {error
                                        ?
                                        <p>{errorMessage}</p>
                                        :
                                        <></>
                                    }
                                </div>
                            </div>
                            <div className="synModal__buttomArea">
                                <h2>OR YOU CAN:</h2>
                                <button className="edit-button syncAll" onClick={() => handleSyncAll()}>Sync all</button>
                                <div className="synModal__alert">
                                    <p><img src="https://cdn.shopify.com/s/files/1/0622/8577/5024/files/alert.png?v=1701881196" /> <span>WARNING!</span>  CHANGES CANNOT BE UNDONE</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}